import { render, staticRenderFns } from "./EmailGroupsTable.vue?vue&type=template&id=082bc48e&scoped=true"
import script from "./EmailGroupsTable.vue?vue&type=script&lang=js"
export * from "./EmailGroupsTable.vue?vue&type=script&lang=js"
import style0 from "./EmailGroupsTable.vue?vue&type=style&index=0&id=082bc48e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082bc48e",
  null
  
)

export default component.exports